import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import { Flex, Shimmer, FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

const SaleBadge = styled(Flex).attrs((props) => ({
  alignItems: "center",
  bg: "sale",
  borderRadius: props.BF ? "6px" : "2px",
  color: "white",
  display: "inline-flex",
  fontSize: "14px",
  fontWeight: "700",
  justifyContent: "center",
  letterSpacing: props.BF ? "1px" : "3px",
  lineHeight: "16px",
  mb: "10px",
  px: 1,
  py: "4px",
  ...props,
}))``

const Badge = ({ forBestDeal, onSale, prefStore, wizardLoading }) => {
  const BF = sl.config.sale_key.includes("2024_black_friday")
  if (wizardLoading || !prefStore) {
    return <Shimmer height="24px" mb="10px" width="120px" />
  }

  if (BF && forBestDeal) {
    return (
      <SaleBadge BF>
        <FontAwesomeIcon color="white" fontSize="16px" icon={faTag} mr="6px" />
        BEST DEAL
      </SaleBadge>
    )
  } else if (onSale) {
    return <SaleBadge>SALE</SaleBadge>
  } else return null
}

Badge.propTypes = {
  forBestDeal: PropTypes.bool,
  onSale: PropTypes.bool,
  prefStore: PropTypes.bool,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    forBestDeal: state.wizard.forBestDeal,
    onSale: state.choices.sku && !!state.choices.sku.sale_price,
    prefStore: state.wizardUI.prefStore,
    wizardLoading: state.wizard.loading,
  }
}

export default connect(mapStateToProps)(Badge)
